<template>
  <b-row class="d-flex align-items-center">
    <b-col cols="5" class="">
      <dropdown-checkbox-grouped :options="researchTeamRoles" :optionField="'text'" :valueField="'value'" :input="action.role" :id="`notify-research-team-dropdown-${index}`" @selected-grouped-checkbox-data="selectedElementsFromResearchTeamDropdown($event)" />
    </b-col>

    <b-col cols="1" class="ml-auto" v-if="index > 0">
      <button class="btn btn-link color_red mb-11 pr-0" v-on:click="deleteAnotherAction()">
        <img height="32" width="32" src="static/img/light-gray-delete.svg" />
      </button>
    </b-col>

    <!-- Custom message textarea start -->
    <b-col cols="12" v-if="action['role'] && ((action['role']['studyTeam'] && action['role']['studyTeam'].length > 0) || (action['role']['siteTeam'] && action['role']['siteTeam'].length > 0)) && (action['message'] == null || action['message'] == undefined)">
      <b-form-textarea id="textarea" v-model="teamMessage" placeholder="Enter Custom Message" maxLength="160" rows="6" max-rows="6" class="custom-message-textarea"></b-form-textarea>

      <!--Save button to save the custom message-->
      <em class="text-counter">{{ textCharLimit }} character limit</em>
      <button class="message-save-btn" @click="saveSiteTeamMessage()">
        Save
      </button>
    </b-col>
    <!-- Custom message textarea ends -->

    <!-- Custom message displayed on the screen start -->
    <b-col cols="12" v-if="action['message'] != null || action['message'] != undefined" class="pt-17">
      <p v-if="action['message'] === ''" class="message-box no-custom-msg">
        No custom message
      </p>
      <p v-else class="message-box">{{ action.message }}</p>
    </b-col>
  </b-row>
</template>
<script>
import DropdownCheckboxGrouped from "./dropdown-checkbox-grouped";

export default {
  name: "notify-research-team",
  components: {
    DropdownCheckboxGrouped
  },
  props: {
    action: {
      type: Object,
      required: false,
      default: null
    },
    researchTeamRoles: {
      type: Object,
      required: false,
      default: null
    },
    index: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    textCharLimit() {
      return this.updateTextLimit();
    }
  },
  watch: {
    action: {
      deep: true,
      immediate: true,
      handler: function(newData) {
        if (newData) {
          if (newData["role"] && newData["message"] && !this.teamMessage) {
            /* Initialize teamMessage with action['message'] value in case of edit, only for 1 time. */
            this.teamMessage = newData["message"];
          }
        }
      }
    }
  },
  data() {
    return {
      charLimit: 160,
      teamMessage: null
    };
  },
  methods: {
    updateTextLimit() {
      if (!this.teamMessage) {
        return (this.charLimit = 160);
      }
      return (this.charLimit = 160 - this.teamMessage.length);
    },
    selectedElementsFromResearchTeamDropdown(data) {
      this.$emit("selected-research-team-data", data);
    },
    deleteAnotherAction() {
      this.$emit("delete-another-action", null);
    },
    saveSiteTeamMessage() {
      if (!this.isMessageValid()) {
        this.teamMessage = "";
      }

      this.$emit("save-site-team-message", this.teamMessage);
    },
    isMessageValid() {
      if (!(this.teamMessage && this.teamMessage.trim())) {
        return false;
      }
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-message-textarea {
  margin-bottom: 15px;
  resize: none;
}

.message-box {
  padding: 10px;
  border-radius: 3px;
  border: solid 1px #d3dfe4;
  color: #666669;
  font-size: 14px;
  word-break: break-word;

  &.no-custom-msg {
    font-style: italic;
    opacity: 0.5;
  }
}

.text-counter {
  position: absolute;
  right: 95px;
  bottom: 30px;
  color: #666669;
  font-size: 12px;
  opacity: 0.5;
}

.message-save-btn {
  position: absolute;
  right: 25px;
  bottom: 25px;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: #4c8ce4;
  color: #fff;
  border: none;
  cursor: pointer;

  &:disabled {
    background-color: #bcd4f5;
    cursor: not-allowed;
  }
}
</style>
